import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { EMap } from '@mode/reports/sandbox/contract';
import { EmbedReportFilterFacade } from '../../domain/embed-report-filter.facade';
import { CommonModule } from '@angular/common';
import { LegacyReportFilterControl } from '@mode/filters/util';
import { ModeModel, ReportTypes } from '@mode/shared/contract-common';
import { FiltersContainerComponent } from '@mode/filters/ui-filters-library';

@Component({
  imports: [CommonModule, FiltersContainerComponent],
  standalone: true,
  selector: 'mode-report-viewer-filters-container',
  templateUrl: './viewer-filters-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportViewerFiltersContainerComponent implements OnInit {
  filterControls$: Observable<ReadonlyArray<ReportTypes.ReportFilterControl>>;
  filterOptions$: Observable<EMap<ReportTypes.ReportFilterOptions>>;
  isFilterPanelOpen$: Observable<boolean>;
  datasetsLoading$: Observable<boolean>;
  orphanedFilters$: Observable<Set<string>>;
  filterOptionCounts$: Observable<EMap<number>>;
  filterOptionSelectedCounts$: Observable<EMap<number>>;
  model$: Observable<ModeModel>;
  buttonPosition$: Observable<string>;
  isEmbedded$: Observable<boolean>;
  showSettingsMenu = false;

  constructor(private filterFacade: EmbedReportFilterFacade) {}

  ngOnInit(): void {
    this.filterControls$ = this.filterFacade.filterControls$;
    this.filterOptions$ = this.filterFacade.filterOptions$;
    this.filterOptionCounts$ = this.filterFacade.filterOptionCounts$;
    this.filterOptionSelectedCounts$ = this.filterFacade.filterOptionSelectedCounts$;
    this.datasetsLoading$ = this.filterFacade.datasetsLoading$;
    this.isFilterPanelOpen$ = this.filterFacade.isFilterPanelOpen$;
    this.orphanedFilters$ = this.filterFacade.orphanedFilters$;
    this.model$ = this.filterFacade.model$;
    this.buttonPosition$ = this.filterFacade.buttonPosition$;
    this.isEmbedded$ = this.filterFacade.isEmbedded$;
  }

  onFiltersApply(records: LegacyReportFilterControl[]) {
    this.filterFacade.handleFiltersApply(records);
  }

  onFiltersApplyAndGenerateLink(records: LegacyReportFilterControl[]) {
    this.filterFacade.handleFiltersApply(records);
    this.filterFacade.handleFiltersApplyAndGenerateLink(records);
  }

  onFiltersReset(records: LegacyReportFilterControl[]) {
    this.filterFacade.resetAllFilters(records);
  }

  onFiltersSetAsDefault(records: LegacyReportFilterControl[]) {
    this.filterFacade.handleFiltersSetDefault(records);
  }

  onFilterMove(filter: LegacyReportFilterControl, nextToken: string) {
    this.filterFacade.moveToPosition(filter, nextToken);
  }

  onFilterDelete(filter: LegacyReportFilterControl) {
    this.filterFacade.deleteFilter(filter);
  }

  onFilterSelectionChange(filter: LegacyReportFilterControl) {
    this.filterFacade.selectionChanged(filter);
  }
}
